import script from "./ColorFilmstrip.vue?vue&type=script&setup=true&lang=js"
export * from "./ColorFilmstrip.vue?vue&type=script&setup=true&lang=js"

import "./ColorFilmstrip.vue?vue&type=style&index=0&id=dca3a4a2&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dca3a4a2"]])

export default __exports__